<section *ngIf="bundleLoaded && !displaySafariInstructions && !mobileInstructions && !pageNotFound" class="citiShop">
    <app-citi-shop-header [contentHeader]="csp.isBrowser() ? contentText : {}" [userEnrolled]="userIsEnrolled"
        (ctabuttonClicked)="ctabuttonClicked($event)">
    </app-citi-shop-header>

    <div class="backgroundImage hideBackgroundImage" role="presentation" alt=""
        [style]="'background-image: url('+csp.imagePrefix() + contentText?.backgroundImagePath+')'">
        @if (userIsEnrolled) {
        @if(content?.staticOffersWall?.active){
        <static-offers-wall [staticOffersWall]="content.staticOffersWall"></static-offers-wall>
        }
        @if(content?.nonMerchantSearch?.active){
        <non-merchant-search [nonMerchantSearchData]="content?.nonMerchantSearch"></non-merchant-search>
        }
        }
        @else if(!userIsEnrolled){
        <app-citi-shop-program [contentProgram]="content.programSection" [userEnrolled]="userIsEnrolled"
            (ctabuttonClicked)="ctabuttonClicked($event)">
        </app-citi-shop-program>
        @if(content?.staticOffersWall?.active){
        <static-offers-wall [staticOffersWall]="content.staticOffersWall"></static-offers-wall>
        }
        }
        <app-citi-shop-video *ngIf="videoSectionContent?.isActive" [videoContent]="videoSectionContent">
        </app-citi-shop-video>
        <app-citi-shop-download [contentDownload]="content.downloadSection"
            (ctabuttonClicked)="ctabuttonClicked($event)">
        </app-citi-shop-download>
    </div>
    <app-citi-shop-faq [contentFaq]="content.faqSection" [isUserEnrolled]="userIsEnrolled"
        [contentHeader]="contentText"></app-citi-shop-faq>
    <app-citi-shop-save *ngIf="!userIsEnrolled" [contentSave]="content.saveSection"
        (ctabuttonClicked)="ctabuttonClicked($event)">
    </app-citi-shop-save>
    <app-citi-shop-article [contentArticle]="content.articleSection" *ngIf="!userIsEnrolled"></app-citi-shop-article>
</section>

<section *ngIf="bundleLoaded && mobileInstructions">
    <app-citi-shop-mobile-instructions [contentMobile]="content.mobileInstructions"></app-citi-shop-mobile-instructions>
</section>

<section *ngIf="bundleLoaded && displaySafariInstructions" class="citiShop-safari">
    <app-citi-shop-safari-instructions [contentMobile]="content.mobileInstructions"></app-citi-shop-safari-instructions>
</section>

<app-citi-shop-suspend-dialog *ngIf="showSuspendModal && suspendDialogParams?.isDialogEnable"
    [suspendDialogParams]="suspendDialogParams"></app-citi-shop-suspend-dialog>